module.exports = __webpack_public_path__ + "static/media/fotoInicio.f1f41b62.png";